// Card.js
import React, { useState } from 'react';
import './Card.css';

const Card = ({ title, text, truncateLength = 250 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const shouldTruncate = text.length > truncateLength;
  const displayText =
    isExpanded || !shouldTruncate ? text : text.slice(0, truncateLength) + '...';

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div className="card">
      <h3>{title}</h3>
      <p>{displayText}</p>
      {shouldTruncate && (
        <button onClick={toggleExpand} className="read-more-btn">
          {isExpanded ? "Afișează mai puțin" : "Citește mai mult"}
        </button>
      )}
    </div>
  );
};

export default Card;
